import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { ListiniApi, GetListiniAnimaliDettagliRequest, GetListiniMangimiDettagliRequest } from "../data/apis/ListiniApi";

export function listiniMangimiDettaglioDataSource(idListinoTestata: number, showAll: boolean) {
    return new CustomStore({
        key: "id",
        loadMode : 'raw',
        load: (loadOptions) => {
            const api = new ListiniApi(apiConfiguration);

            const request: GetListiniMangimiDettagliRequest = {
                idListinoTestata: idListinoTestata,
                showAll: showAll
            };

            return api.getListiniMangimiDettagli(request);
        },

        byKey: (key) => {
            const api = new ListiniApi(apiConfiguration);

            return api.getListinoMangimiDettaglioById({
                id: key
            });
        },

        insert: (values) => {
            const api = new ListiniApi(apiConfiguration);

            return api.insertListinoMangimiDettaglio({
                idListinoTestata: idListinoTestata,
                listinoMangimiDettaglioCreateDTO: values
            });
        },

        update: (key, values) => {
            const api = new ListiniApi(apiConfiguration);
            return api.updateListinoMangimiDettaglio({
                id: key,
                listinoMangimiDettaglioUpdateDTO: values
            });
        },

        remove: (key) => {
            const api = new ListiniApi(apiConfiguration);
            return api.deleteListinoMangimiDettaglio({
                id: key,
            });
        }
    });
}